import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpEvent, HttpHandler, HttpHandlerFn, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { DomainResolverService } from '@services/domain-resolver.service';
import { API_URL } from '@core/tokens/api.token';
import { Observable } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

// Simple cache with automatic cleanup
const tenantCache = new Map<string, { timezone: string; offset: string; expires: number }>();
const CACHE_TTL = 6 * 60 * 60 * 1000; // 6 hours
const MAX_CACHE_SIZE = 100;
@Injectable()
export class DomainInterceptor implements HttpInterceptor {
  private readonly apiUrl = inject(API_URL);
  private readonly domainService = inject(DomainResolverService);
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!req.url.startsWith(this.apiUrl)) {
      return next.handle(req);
    }
    const currentHost = this.domainService.getHostname();
    // const currentHost = 'gattinonib2b2c.draft2017.com';// test draft
    // const currentHost = 'valairagency.draft2017.com';// test draft
    // const currentHost = 'admin.gattinonimondodivacanze.it';// test production
    // const currentHost = 'centroviaggigraffiti.it';// test production

    if (!currentHost) return next.handle(req);

    const now = Date.now();
    if (!this.isBrowser) {
      const cached = tenantCache.get(currentHost);
      if (cached && now < cached.expires) {
        return next.handle(
          req.clone({
            setHeaders: {
              'X-Man': 'Ndershkuesi',
              'X-Timezone': cached.timezone,
              'X-Timezone-Offset': cached.offset,
              'X-Domain-Host': currentHost,
            },
          })
        );
      }

      if (tenantCache.size > MAX_CACHE_SIZE) {
        for (const [host, data] of tenantCache.entries()) {
          if (now >= data.expires) {
            tenantCache.delete(host);
          }
        }
      }
    }

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    const offset = String(new Date().getTimezoneOffset());

    if (!this.isBrowser) {
      tenantCache.set(currentHost, {
        timezone,
        offset,
        expires: now + CACHE_TTL,
      });
    }
    
    return next.handle(
      req.clone({
        setHeaders: {
          'X-Man': 'Ndershkuesi',
          'X-Timezone': timezone,
          'X-Timezone-Offset': offset,
          'X-Domain-Host': currentHost,
        },
      })
    );
  }
}
